import React from "react";

import FulfillmentType from "@/enum/FulfillmentType";
import ProxyImage from "@/components/ProxyImage";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import { message } from "antd";

import copy from "copy-to-clipboard";
import OrderTab from "../../enum/OrderTab";
import OrderTabNameMap from "../../map/OrderTabNameMap";
import { useOrderManagementStore } from "../../store/OrderManagementStore";

interface OrderTableEmptyProps {
    shop: ShopDTO;

    fulfillmentType: FulfillmentType;

    isShowFulfillment: boolean;

    tab: OrderTab;
}

const OrderTableEmpty: React.FC<OrderTableEmptyProps> = function (props) {
    const { shop, fulfillmentType, isShowFulfillment, tab } = props;

    const orderManagementStore = useOrderManagementStore();

    if (
        shop.type === ShopType.PDD_FDS ||
        shop.type === ShopType.ALIBABA_SUPPLIER ||
        shop.type === ShopType.DOUDIAN_IOP
    ) {
        return (
            <tbody key="#table-empty#">
                <tr>
                    <td colSpan={orderManagementStore.storage.visibleColumnCount} className="not-order-found">
                        <div className="mt20 mb20">
                            <div>
                                <img
                                    src="https://img.alicdn.com/imgextra/i1/54458674/O1CN01vOZSl12DwkE3UE0N9_!!54458674.png"
                                    alt=""
                                />
                                <div>
                                    <div style={{ fontSize: 16, marginBottom: 8, fontWeight: 600 }}>
                                        没找到相关订单，请先同步订单。同步后仍然没有，可能代理商没有给你分配订单
                                    </div>

                                    <div style={{ fontSize: 14, fontWeight: 600 }} className="text-gray">
                                        <span
                                            style={{
                                                backgroundColor: "#eef4fb",
                                                color: "#497ab2",
                                                borderRadius: 14,
                                                fontSize: 14,
                                                padding: "6px 12px",
                                                marginRight: 6,
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                                if (shop.type === ShopType.DOUDIAN_IOP) {
                                                    copy("https://fxg.jinritemai.com/ffa/morder/distribution/merchant");

                                                    message.success("复制成功");
                                                } else if (shop.type === ShopType.PDD_FDS) {
                                                    copy("https://mms.pinduoduo.com/print/deliver-manage");

                                                    message.success("复制成功");
                                                } else if (shop.type === ShopType.ALIBABA_SUPPLIER) {
                                                    copy("https://sell.alibaba.com/order/index.html");

                                                    message.success("复制成功");
                                                }
                                            }}
                                        >
                                            复制链接
                                        </span>
                                        <span>给代理商打开，看看是否有给你分配订单</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    }

    if (fulfillmentType === FulfillmentType.DROP_SHIPPING && isShowFulfillment) {
        return (
            <tbody key="#table-empty#">
                <tr>
                    <td colSpan={orderManagementStore.storage.visibleColumnCount} className="not-order-found">
                        没找到相关订单，当前店铺: {shop?.name}
                    </td>
                </tr>
                <tr>
                    <td colSpan={orderManagementStore.storage.visibleColumnCount}>
                        <div className="p50 flex ">
                            <div className="left">
                                <p className="mb10">
                                    代发订单：指店铺的订单提交给了供货商/厂家发货，提交方式有手动和自动两种
                                </p>
                                <div>
                                    <span>1 手动批量提交给供货商/厂家：【全部订单】或者【自有订单】下都可提交</span>

                                    <a
                                        href="https://qw15p3s8hv.feishu.cn/wiki/wikcnCrGMDo2IKIsIrtMmtuXTbd"
                                        target="_blank"
                                    >
                                        详细教程
                                    </a>

                                    <p className="mt10">
                                        <ProxyImage
                                            src="https://img.alicdn.com/imgextra/i2/54458674/O1CN01Lfv9m12DwkCzZSEPh_!!54458674.png"
                                            width={800}
                                        />
                                    </p>
                                </div>
                            </div>

                            <div className="right ml20">
                                <p className="mt30">
                                    2 全自动提交给供货商/厂家
                                    <Link to="/partnership/retailer/autoPushOrderSetting" className="ml10">
                                        去设置自动提单
                                    </Link>
                                    <a
                                        href="https://qw15p3s8hv.feishu.cn/wiki/wikcnuwDT1UF0hkmVg53n7eClVU"
                                        target="_blank"
                                        className="ml10"
                                    >
                                        详细教程
                                    </a>
                                </p>
                                <p className="mt10">
                                    <ProxyImage
                                        src="https://img.alicdn.com/imgextra/i2/54458674/O1CN015BKyBb2DwkCz2WCXU_!!54458674.png"
                                        width={800}
                                    />
                                </p>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    }

    return (
        <tbody key="#table-empty#">
            <tr>
                <td colSpan={orderManagementStore.storage.visibleColumnCount}>
                    <div className="tc">
                        <div className="mb10">
                            <p style={{ fontSize: "15px" }}>
                                {OrderTabNameMap[tab]}下未查询到相关订单 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当前店铺:
                                {shop?.name}
                            </p>
                        </div>

                        <div className="inline-block tl">
                            <p>1.请同步订单到最新时间或者检查下查询条件</p>
                            <p>2.订单可能不是“ {OrderTabNameMap[tab]}”了，试试在其他状态查询</p>
                            <p>
                                3.可使用“<Link to="/order/search">快速查单</Link>”功能
                            </p>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    );
};

export default observer(OrderTableEmpty);
